/** Browser speechSynthesis helper for voice-bot Tier-1 TTS. */

function preferredEnglishVoice(): SpeechSynthesisVoice | null {
  if (typeof window === 'undefined' || !('speechSynthesis' in window)) return null;
  const voices = window.speechSynthesis.getVoices();
  if (!voices.length) return null;
  return (
    voices.find((v) => v.lang.startsWith('en') && /samantha|jenny|google us english|zira|aria/i.test(v.name)) ??
    voices.find((v) => v.lang.startsWith('en-US')) ??
    voices.find((v) => v.lang.startsWith('en')) ??
    null
  );
}

export function isBrowserTtsSupported(): boolean {
  return typeof window !== 'undefined' && 'speechSynthesis' in window;
}

/** Warm voice list (Chrome loads voices asynchronously). */
export function preloadBrowserTtsVoices(): void {
  if (!isBrowserTtsSupported()) return;
  window.speechSynthesis.getVoices();
}

export function stopVoiceBotSpeech(): void {
  if (!isBrowserTtsSupported()) return;
  window.speechSynthesis.cancel();
}

export function speakVoiceBotText(text: string): void {
  const trimmed = text.trim();
  if (!trimmed || !isBrowserTtsSupported()) return;

  window.speechSynthesis.cancel();
  const utterance = new SpeechSynthesisUtterance(trimmed);
  utterance.lang = 'en-US';
  utterance.rate = 1;
  const voice = preferredEnglishVoice();
  if (voice) utterance.voice = voice;
  window.speechSynthesis.speak(utterance);
}
